<button
  class="btn btn-secondary"
  [ngClass]="signInClass()"
  (click) = "login()"
  translate
>
  account.signin.auth0.button.label
</button>

  <!-- routerLink="/login" -->
     <!-- [queryParams]="{ returnUrl: returnUrl }" -->